module.exports = __webpack_public_path__ + "static/media/containerTrucker.b08c7bbf.jpg";